export default {
  cove: {
    api: process.env.COVE_API,
    ui: process.env.COVE_UI,
    toslink: 'https://s3-us-west-2.amazonaws.com/cove-deal-files/CoveTermsofUse.html',
    privacylink: 'https://s3-us-west-2.amazonaws.com/cove-deal-files/CovePrivacyPolicy.html'
  },
  auth0: {
    clientId: process.env.AUTH0_CLIENT_ID,
    domain: process.env.AUTH0_DOMAIN,
  },
  sentry: {
    dsn: process.env.SENTRY_DSN
  },
  mixpanel: {
    token: process.env.MIXPANEL_TOKEN
  },
  plaid: {
    env: process.env.PLAID_ENV,
    client: process.env.PLAID_CLIENT_ID,
    apiKey: process.env.PLAID_PUBLIC_KEY,
  }
};



// WEBPACK FOOTER //
// ./mobile/shared/config.js